import { SVGAttributes } from 'react';

export default function (props: SVGAttributes<SVGElement>) {
    return (
        <svg viewBox="0 0 12 12" width={12} height={12} {...props}>
            <path
                fill="currentColor"
                d="M10.476 2.013a.25.25 0 00-.422.081L9.5 3.629a1 1 0 01-.805.621H7.277a.25.25 0 00-.193.36l.443 1.14a.25.25 0 00.223.139h.414a.25.25 0 01.224.361L7 9.096a1.014 1.014 0 01-1.933-.124L4.57 6.888a.25.25 0 00-.224-.138h-.222a1.625 1.625 0 010-3.25h2.05a.25.25 0 00.25-.25v-.573A1 1 0 005.8 1.75l-.142-.057a.25.25 0 01-.032-.45l1.361-.7a.25.25 0 00-.075-.47A5.822 5.822 0 006 0a6.013 6.013 0 104.476 2.013z"
            />
        </svg>
    );
}
